<template>
  <div class="row">

  </div>
</template>

<script>
import {mapActions} from 'vuex'

export default {
  name: "Logout",
  mounted() {
    this.logout()
        .catch(console.log)
        .finally(() => {
          localStorage.clear();
          this.$router.push("/").catch(() => null);
        })
  },
  methods: {
    ...mapActions({
      logout: "Api/Users/logout"
    }),
  }
}
</script>

<style scoped>

</style>
